export const routeConstants =
{
    LandingPage: '/',

    ContactModal: '/contact',
    UploadPolicyModal: '/uploadpolicy',
    BookMeetingModal: '/bookmeeting',

    queryString: sessionStorage.getItem('locationSearch') || ''
};

